export default __webpack_public_path__ + "static/Tip-8-Meditate-22ed9b9a54c104026f1d4297d0bf8a8d.jpg";